<template>
	<div class="transimport componetself">
		<!-- 批量导入到货计划 -->
		<div class="body_btns headbtn">
			<vxe-button @click="EXPORT" type="text" :loading="exload" :disabled="!VAIL.SFILE||SFILE||exload"
				class="tool-btn _icon_button btnbpadding" title="导出模板文件">
				导出模板文件
			</vxe-button>
			<vxe-button @click="GETFILE" type="text" :loading="SFILE" :disabled="!VAIL.SFILE||SFILE||exload"
				class="tool-btn _icon_button btnbpadding" title="选择文件">
				选择文件
			</vxe-button>
			<vxe-button type="text" @click="FORERPIMPORT" :loading="SIMBTN" :disabled="!VAIL.SIMBTN||SIMBTN||exload"
				class="tool-btn _icon_button btnbpadding"   title="到货计划导入">
				到货计划导入
			</vxe-button>
			<vxe-button type="text" @click="RESET"
				class="tool-btn _icon_button btnbpadding"   title="清空">
				清空
			</vxe-button>
		</div>
		<div class="componet_body">
			<div class="body_content">
				<!-- checkbox -->
				<c-table ref="ctablemain" :coltype="'seq'"  :calculate="false" :table="table"  @FitColumns="table.head=$event"></c-table>
	
			</div>
		</div>
		
		<el-dialog class="IMPORTLOAD"  :visible.sync="UPLOAD" :close-on-press-escape="false"
			:close-on-click-modal="false" :before-close="UPDALOADCLOSE" :show-close="false">
			{{UPLOADJD.FINAL?'上传成功':'上传文件中'}}（{{UPLOADJD.CUR}}/{{UPLOADJD.TOTAL}}）
			<br>
			<template v-if="UPLOADJD.FINAL">读取文件中，请稍后</template>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		props:{
			menuId: {
				type: String,
				default:''
			},
		},
		data(){
			return{
				table:{
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined
				},
				exload:false,
				SFILE: false,
				SIMBTN: false,
				VAIL: {
					SFILE: true,
					SIMBTN: false
				},
				UPLOAD:false,
				UPLOADJD:{
					TOTAL:0,
					CUR:0,
					FINAL:false
				},
				fileName:''
			}
		},
		computed:{
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			npageId(){
				console.log(this.$store.state.openedTabs)
				let _tab=this.$store.state.openedTabs.filter(tab=>tab.menuId==this.menuId);
				if(_tab.length>0){
					return (_tab[0].route||{}).pageId;
				}
				return '';
			}
		},
		methods:{
			//到处模板文件
			EXPORT() {
				try {
					if (this.exload) return;
					this.exload = true;
					//梳理数据的
					this.exportDataReq((res) => {
						if(res!='sucess')
							this.exload = false;
					});
				} catch (e) {
					this.$BH().message(e);
					this.exload = false;
				}
			},
			exportDataReq(callback) {
				this.$BH().base.http({
					url: 'Web/Trans_EXPORTT',
					data: {
						FUser:this.userinfo.pfnumber,
						gysFUser:this.userinfo.fnumber,
						FType:this.userinfo.accountType,
						pageId:this.npageId,
					},
					success: (res) => {
						let {
							value
						} = res.data;
						let basestr = res.data.value;
						if (basestr == '') {
							this.$BH().message('返回数据错误');
							callback && callback();
						} else
							this.$BH().DownLoadBase64({
								data: {
									name: (this.npageId=='cg'?'标准':'委外')+'到货计划导入模板' + new Date().format('yyyyMMddhhmmss'),
									base64Str: basestr
								},
								loadingcontrol: () => {
									this.exload = false;
								}
							});
					},
					loadingcontrol: callback
				})
			},
			RESET() {
				try {
					this.$BH().confirm('确定清空当前的数据吗？', () => {
						//确认以后清空重置当前的数据
						this.table = {
							pagesize: 100,
							currentPage: 1,
							head: [],
							data: [],
							_height: undefined
						}
						this.SFILE = false
						this.SIMBTN = false
						this.VAIL = {
							SFILE: true,
							SIMBTN: false
						}
					});
			
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			UPDALOADCLOSE(){
				try{
					this.UPLOAD=false
					this.UPLOADJD={
						TOTAL:0,
						CUR:0,
						FINAL:false
					}
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			//获取选择的文件
			GETFILE() {
				try {
					if (this.SFILE) return;
					this.SFILE = true;
					let _this=this;
					//同步上传之后 紧接着读取
					var DOREQY=(fd,onSuccess)=>{
						console.log(fd,fd.get('FINAL'));
						let FINAL=fd.get('FINAL')=='true';
						this.UPLOADJD.FINAL=FINAL;
						this.$BH().base.http({
							// baseUrl:'http://127.0.0.1:44351/',
							url: 'Web/RECIREFILE_READ',
							data: fd,
							success: (res) => {
								console.log(res)
								if(!FINAL){
									onSuccess&&onSuccess(fd)
								}
								else{
									//已经是最后的
									//开始读取返回的数据
									console.log('----jieshu' )
									this.SFILE = false;
									this.UPLOAD=false;
									//读取赋值
									let {head,data}=res.data.value;
									this.table.data=data;
									this.table.head=head;
									this.$refs.ctablemain?.updateCoulm();
									this.VAIL.SFILE=false;
									this.VAIL.SIMBTN=true;
								}
							},
							loadingcontrol:(res)=>{
								if(res!='success')
									this.SFILE = false,this.UPLOAD=false;
							}
						})
					}
					this.$BH().base.Dom.getFile(function() {
						let files = this.files;
						if(files.length>1){
							_this.$BH().message('请选择一个文件');
							this.value = '';
							return;
						}
						let fileName = files[0].name;
						_this.fileName=fileName;
						let suffix = fileName.substring(fileName.lastIndexOf('.') + 1);
						if (suffix != "xls" && suffix != 'xlsx') { //校对文件格式
							_this.$BH().message('文件格式错误,请重新选择');
							this.value = '';
							return;
						}
						//上传文件数据 分段式上传
						function uploadFileBLOB (file,_value){
							var reader = new FileReader();
							var step = 120670;//1024 * 1024;
							var total = file.size;
							var cuLoaded = 0;
							var startTime = new Date();
							_this.UPLOAD=true;
							_this.UPLOADJD.TOTAL=Math.ceil(total/step);
							//将分段数据上传到服务器
							let date=new Date()
							let tempname=date.getTime()+'UPLOAD'+ _value.FUSER.replace('.','');
							//读取一段成功
							reader.onload = function(e) {
								//处理读取的结果
								var loaded = e.loaded;
								// realupload.push({'name':file.name,'tempname':tempname})
								uploadFile(reader.result, cuLoaded,tempname, function(fd) {
									//加载结束判断一次
									//如果没有读完，继续
									cuLoaded+= loaded;
									let isload=!loaded;
									if (cuLoaded < total&&!isload) {
										_this.UPLOADJD.CUR=cuLoaded/step;
										readBlob(cuLoaded);
									}else {
										_this.UPLOADJD.CUR=_this.UPLOADJD.TOTAL;
										cuLoaded = total;
										fd.append('FINAL',true);
										//上传成功后开始读取数据
										DOREQY(fd,()=>{
											console.log('----FINAL')
											// DOREQY(fd)
										})
									}
								});
							}
							//指定开始位置，分块读取文件
							function readBlob(start) {
								//指定开始位置和结束位置读取文件
								var blob = file.slice(start, start + step);
								reader.readAsArrayBuffer(blob);
							}
							//开始读取
							readBlob(0);
							function uploadFile(result, startIndex,tempname, onSuccess) {
								console.log('startIndex----',startIndex)
								var blob = new Blob([result]);
								//提交到服务器
								var fd = new FormData();
								fd.append('file', blob);
								fd.append('FUSER', _value.FUSER);
								fd.append('fileName', _value.fileName);
								fd.append('suffix', _value.suffix);
								fd.append('FCGTYpe', _value.FCGTYpe);
								fd.append('key', tempname);
								fd.append('startIndex', startIndex);//如果该值是0的时候就 是刚开始读取 本次开始的下表
								console.log(startIndex)
								DOREQY(fd,()=>{
									onSuccess(fd)
								})
							}
						}
						uploadFileBLOB(files[0], {
							fileName:fileName,
							FUSER:_this.userinfo.fnumber,
							suffix:suffix,
							FCGTYpe:_this.npageId
						})
					}, () => {
						this.SFILE = false;
						this.UPLOAD=false;
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.SFILE = false;
					this.UPLOAD=false;
				}
			},
			FORERPIMPORT(){
				try{
					if(this.table.data.length==0) throw '请先导入文件数据';
					if(this.SIMBTN) return;
					this.SIMBTN=true;
					this.$BH().base.http({
						url: 'Web/Trans_IMPT',
						data: {
							FUser:this.userinfo.pfnumber,
							gysFUser:this.userinfo.fnumber,
							FType:this.userinfo.accountType,
							FIMPDATA:this.table.data,
							FFileName:this.fileName,
							pageId:this.npageId
						},
						success: (res) => {
							console.log(res);
							this.$BH().message(res.data.value);
							this.VAIL.SIMBTN=false;
						},
						loadingcontrol:(res)=>{
							this.SIMBTN=false;
						}
					});
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.SIMBTN=false;
				}
			},
		}
	}
</script>

<style>
</style>